const playback = {
  path: 'playback',
  component: resolve => require(['../../../../../pages/teacher/course/calendar/playback'], resolve)
}

export default playback



// WEBPACK FOOTER //
// ./src/router/teacher/course/calendar/playback/index.js